import { ReactElement, useEffect, useState } from 'react';
import { PageHelmet } from '../../components/PageHelmet';
import { useWindowSizeStore } from '../../stores/useWindowSizeStore';
import { BannerImage } from '../../components/BannerImage';
import GenerateLinkScreen from '../../components/GenerateLinkBussiness';

export function BuildIncludeFunctionary(): ReactElement {
  const width = useWindowSizeStore(state => state.width);
  return (
    <div className="overflow-hidden">
      <PageHelmet title="Gerar Link Empresa | OdontoGroup" />

      <BannerImage page="plan" imgSource="/assets/images/plan-banner.jpg" />
      <div className="">
        <GenerateLinkScreen />
      </div>
    </div>
  );
}
